<div class="partner-edit">
  <div class="partner-edit__content">
    <div class="partner-edit__layout">
      <div class="partner-edit__header">
        <div class="partner-edit__heading">
          <h1 class="page-title">Edit Partner</h1>
          <p class="page-subtitle">Update partner information and address details.</p>
        </div>
        <div class="partner-edit__actions">
          <app-button type="button" variant="secondary" (click)="goBack()">Back</app-button>
          <app-button type="button" [disabled]="isSaving || partnerForm.invalid || !partnerId || !isReady" (click)="savePartner()">
            {{ isSaving ? "Saving..." : "Save changes" }}
          </app-button>
        </div>
      </div>

      @if (isReady) {
      <app-card>
        <form [formGroup]="partnerForm" class="partner-edit__form">
          <div class="partner-edit__form-grid">
            <div class="partner-edit__form-field">
              <div class="partner-edit__form-label-row">
                <label for="name" class="partner-edit__form-label">Partner Name</label>
              </div>
              <input
                id="name"
                type="text"
                formControlName="name"
                autocomplete="off"
                class="partner-edit__form-input"
                [class.partner-edit__form-input--error]="partnerForm.get('name')?.invalid && partnerForm.get('name')?.touched" />
              @if (partnerForm.get('name')?.invalid && partnerForm.get('name')?.touched) {
              <div class="partner-edit__form-error">Partner name is required and must be at least 2 characters</div>
              }
            </div>

            <div class="partner-edit__form-field">
              <div class="partner-edit__form-label-row">
                <label for="type" class="partner-edit__form-label">Type</label>
              </div>
              <app-autocomplete
                [prefetchOnInit]="true"
                [options]="typeOptions"
                [selectedValue]="partner?.type || ''"
                placeholder="Search type..."
                [minLength]="1"
                [debounceMs]="200"
                (selectionChange)="onTypeChange($event)" />
              @if (partnerForm.get('type')?.invalid && partnerForm.get('type')?.touched) {
              <div class="partner-edit__form-error">Type is required</div>
              }
            </div>
          </div>
        </form>
      </app-card>

      <app-card class="partner-edit__address-card">
        <div class="partner-edit__section-header">
          <div>
            <h2 class="partner-edit__section-title">Address Information</h2>
            <p class="partner-edit__section-hint">Update the location hierarchy and address details.</p>
          </div>
        </div>

        <app-location-selector [value]="partner?.address" (addressChange)="onAddressChange($event)"></app-location-selector>
      </app-card>
      }
    </div>
  </div>
</div>
